import { createContext, useContext, useState, useCallback, useMemo, useRef } from "react";
import { ToastContainer } from "../components/ui/Toast";

const ToastContext = createContext();

const MAX_TOASTS = 5;

export function ToastProvider({ children }) {
  const [toasts, setToasts] = useState([]);
  const idRef = useRef(0);

  const removeToast = useCallback((id) => {
    setToasts((prev) => prev.filter((t) => t.id !== id));
  }, []);

  const addToast = useCallback((type, message, duration) => {
    const id = ++idRef.current;
    setToasts((prev) => {
      const next = [...prev, { id, type, message, duration }];
      return next.length > MAX_TOASTS ? next.slice(-MAX_TOASTS) : next;
    });
    return id;
  }, []);

  const toast = useMemo(
    () => ({
      success: (msg, duration) => addToast("success", msg, duration),
      error: (msg, duration) => addToast("error", msg, duration),
      warning: (msg, duration) => addToast("warning", msg, duration),
      info: (msg, duration) => addToast("info", msg, duration),
    }),
    [addToast]
  );

  return (
    <ToastContext.Provider value={toast}>
      {children}
      <ToastContainer toasts={toasts} onClose={removeToast} />
    </ToastContext.Provider>
  );
}

export function useToast() {
  const ctx = useContext(ToastContext);
  if (!ctx) throw new Error("useToast must be used within a ToastProvider");
  return ctx;
}
